// api/axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://square-med-tech-backend.onrender.com/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

export default axiosInstance;
